import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { transformPreviewLink } from '../transformPreviewLink';
import type { PreviewLink } from '../types';

import type {
	PetitionPreviewLinkByIdQuery,
	PetitionPreviewLinkByIdQueryVariables,
} from './getPetitionPreviewLinkById.graphql';
import { PetitionPreviewLinkById } from './getPetitionPreviewLinkById.graphql';

export async function getPreviewLinkById(
	slug: string,
	{ gql: { fetch } }: UtilityContext,
	id: string,
): Promise<PreviewLink | undefined> {
	const { data } = await fetch<PetitionPreviewLinkByIdQuery, PetitionPreviewLinkByIdQueryVariables>({
		query: PetitionPreviewLinkById,
		variables: { slug, id },
		rejectOnError: true,
	});

	const previewLink = transformPreviewLink(
		data.getPetitionPreviewLinkById,
		data.petitionBySlugOrId?.previewLinksImagesConnection,
	);

	return previewLink;
}
